module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_23_A.ad707f8e.mp3";